import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[onlyNumbers]',
  standalone: true,
})
export class OnlyNumbersDirective {
  private specialKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Enter',
    'Escape',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
    'Clear',
    'Copy',
    'Paste',
  ];
  inputElement: HTMLElement;
  condition = false;

  constructor(public el: ElementRef) {
    this.inputElement = el.nativeElement;
  }

  @Input() set onlyNumbers(condition: boolean) {
    this.condition = condition;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    if (this.condition) {
      if (
        this.specialKeys.indexOf(e.key) > -1 ||
        (e.key === 'a' && e.ctrlKey === true) ||
        (e.key === 'c' && e.ctrlKey === true) ||
        (e.key === 'v' && e.ctrlKey === true) ||
        (e.key === 'x' && e.ctrlKey === true) ||
        (e.key === 'a' && e.metaKey === true) ||
        (e.key === 'c' && e.metaKey === true) ||
        (e.key === 'v' && e.metaKey === true) ||
        (e.key === 'x' && e.metaKey === true)
      ) {
        return;
      }

      if (
        (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105)
      ) {
        e.preventDefault();
      }
    }
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(e: KeyboardEvent) {
    if (this.condition) {
      const charCode = e.which ? e.which : e.keyCode;
      if (
        (e.shiftKey || charCode < 48 || charCode > 57) &&
        (charCode < 96 || charCode > 105)
      ) {
        e.preventDefault();
      }
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    if (this.condition) {
      event.preventDefault();
      const pastedInput: string = event.clipboardData
        .getData('text/plain')
        .replace(/\D/g, '');
      document.execCommand('insertText', false, pastedInput);
    }
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    if (this.condition) {
      event.preventDefault();
      const textData = event.dataTransfer.getData('text').replace(/\D/g, '');
      this.inputElement.focus();
      document.execCommand('insertText', false, textData);
    }
  }
}
